import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routing } from './zone.routing';
import { ZoneComponent } from './zone.component';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from '../common/common.module';
@NgModule({
    imports: [
        CommonComponentsModule,
        RouterModule,
        routing,
        CommonModule
    ],
    declarations: [
        ZoneComponent,
    ]
})

export class ZoneModule {}